import './App.css';
import Upper from './Components/UpperDivComponent/Upper';
import Middle from './Components/MiddleDivComponent/Middle';
import React, { Component } from 'react';

class App extends Component{
  constructor(props){
    super(props);
    this.state = {
      darkTheme : true
    }
    this.handleTheme = this.handleTheme.bind(this);
  }
  handleTheme(){
    this.setState({
      darkTheme : !this.state.darkTheme
    })
  }
  render(){
    document.querySelector('body').style.backgroundColor = (this.state.darkTheme) ? 'hsl(235, 21%, 11%)': ' hsl(234, 39%, 85%)';
    return(
      <div className='App'>
        <Upper handleTheme = {this.handleTheme} darkTheme = {this.state.darkTheme}/>
        <Middle darkTheme = {this.state.darkTheme}/>
      </div>
    )
  }
}

export default App;
